import { render, staticRenderFns } from "./ClearSvg.vue?vue&type=template&id=23842e27&"
var script = {}
import style0 from "./ClearSvg.vue?vue&type=style&index=0&id=23842e27&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports